
import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";


import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Homepage from './pages/Homepage/Homepage';
import Auctionpage from './pages/Auctionpage/Auctionpage';
import CollectionItemPage from './pages/CollectionItemPage/CollectionItemPage';
import ItemDetailsPage from './pages/ItemDetailsPage/ItemDetailsPage';
import MyProfilePage from './pages/MyProfilePage/MyProfilePage';
import ActivityPage from './pages/ActivityPage/ActivityPage';
import HowitworksPage from './pages/HowitworksPage/HowitworksPage';
import FAQPage from './pages/FAQPage/FAQPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage/PrivacyPolicyPage';
import ConnectWalletPage from './pages/ConnectWalletPage/ConnectWalletPage';
import AllCollectionsPage from './pages/AllCollectionsPage/AllCollectionsPage';
import CategoryPage from './pages/CategoryPage/CategoryPage';
import FindNFTYouLove from './layouts/Learn/FindNFTYouLove';
import SetUpMetaMaskWallet from './layouts/Learn/SetUpMetaMaskWallet';
import FindMetaMaskWithNFT from './layouts/Learn/FindMetaMaskWithNFT';
import LearnPage from './pages/LearnPage/LearnPage';

function App() {
  return (
    <div className="App min-h-[100vh]">
      <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Homepage />} />
          <Route exact path = '/collections' element = {<AllCollectionsPage />} />
          <Route exact path = '/category/:id' element = {<CategoryPage />} />
          <Route exact path="/auction/:id" element={<Auctionpage />} />
          <Route exact path = '/collection/:id' element = {<CollectionItemPage />} />
          <Route exact path = '/itemdetails/:id' element = {<ItemDetailsPage />} />
          <Route exact path = '/myprofile' element = {<MyProfilePage />} />
          <Route exact path = '/activity' element = {<ActivityPage />} />
          <Route exact path = '/howitworks' element = {<HowitworksPage />} />
          <Route exact path = '/faq' element = {<FAQPage />} />
          <Route exact path = '/privacypolicy' element = {<PrivacyPolicyPage />} />
          <Route exact path = '/connectwallet' element = {<ConnectWalletPage />} />
          <Route path="learn/*" element={<LearnPage />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
